import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { authApi } from "./api/authApi";
import { userApi } from "./api/userApi";
import userReducer from "./features/userSlice";
import accountReducer from "./features/accountSlice";
import configReducer from "./features/configSlice";
import { loggedUserApi } from "./api/loggedUserApi";
import loggedUserReducer from "./features/loggedUserSlice";
import { documentTypeApi } from "./api/documentTypeApi";
import { operationApi } from "./api/operationApi";
import operationReducer from "./features/operationSlice";
import { profesionalActivityApi } from "./api/profesionalActivtyApi";
import { companyApi } from "./api/companyApi";
import stepperReducer from "./features/stepperSlice";
import documentTypeReducer from "./features/documentTypeSlice";
import { provinceApi } from "./api/provinceApi";
import { countryApi } from "./api/countryApi";


export const store: any = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [loggedUserApi.reducerPath]: loggedUserApi.reducer,
    [documentTypeApi.reducerPath]: documentTypeApi.reducer,
    [operationApi.reducerPath]: operationApi.reducer,
    [profesionalActivityApi.reducerPath]: profesionalActivityApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [provinceApi.reducerPath]: provinceApi.reducer,
    [countryApi.reducerPath]: countryApi.reducer,


    userState: userReducer,
    accountState: accountReducer,
    userLoggedState: loggedUserReducer,
    configState: configReducer,
    operationState: operationReducer,
    stepper: stepperReducer,
    documentTypeState: documentTypeReducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat([
      authApi.middleware,
      userApi.middleware,
      // Add the PostApi middleware to the store
      loggedUserApi.middleware,
      documentTypeApi.middleware,
      operationApi.middleware,
      profesionalActivityApi.middleware,
      companyApi.middleware,
      provinceApi.middleware,
      countryApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
